import React from "react";

// @material-ui/icons
import { CircularProgress } from '@mui/material';
import ComplexStatisticsCard from "components/Card/StatisticsCards/ComplexStatisticsCard";
import { Box } from '@mui/material';

import { Alert } from '@mui/material';

import { useQuery } from "react-query";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";

import axios from "axios";
import { getApiCall } from "hooks/axios";

export default function CertCard(props) {
  const url = "/api/v1/k8s/certificates"
  const [token, setToken] = useToken();
  useAxiosAuth(token);

  const { isLoading, error, data } = useQuery(
    "certificate",
    async () => await getApiCall(url, {
      onError: function(error) {
        /// we should handle error here
      }
    }),
  )

  const expireCount = (data) => {
    if (data) {
      let count = {
        'first': 0,
        'second': 0,
        'third': 0,
      };

      if ("items" in data) {
        data.items.forEach((item) => {
          let now = new Date().getTime();
          let expiration = Date.parse(item.expiry);
          let toExpiration = (expiration - now)/(3600*24);
          count['first'] = toExpiration < 90 ? count['first']++ : count['first'];
          count['second'] = toExpiration < 30 ? count['second']++ : count['second'];
          count['third'] = toExpiration < 7 ? count['third']++ : count['third'];
        })
      }

      return count;
    } else {
      return 0
    }
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }

      {isLoading && <CircularProgress size={24} style={{marginLeft: '8%', position: 'fixed', top: '20%', zIndex: '10'}} />}
      <ComplexStatisticsCard
        color={expireCount(data)['first'] > 0 && "error" || "dark"}
        icon="Certs"
        title="Certificate Expiry <90days"
        count={expireCount(data)['first']}
        percentage={{
          color: expireCount(data)['first'] > 0 && "error" || "success",
          amount: "<30days: " +  expireCount(data)['second'] + ", <7days: " + expireCount(data)['third'],
          label: "",
          opacity : isLoading ? '0.7' : '1',
          link: ""
        }}
      />
    </React.Fragment>
  );
}
